<template>
    <div class="page-container">
        <div class="page-top">
            <div class="section-top">
                <div class="top-item">国内承运人：京东快递</div>
                <div class="top-item">订单编号：{{transId}}
                    <span class="btn-copy" v-clipboard:copy="transId" v-clipboard:success="copySucc" v-clipboard:error="copyFail">复制</span>
                </div>
            </div>
            <!-- <div class="section-bottom">
                <span>快递员：XXX</span> <a href="#">联系快递员</a>
            </div> -->
        </div>
        <div class="page-bottom" v-if="list.length">
            <!-- <div class="track-item">
                <img src="../../assets/track-shou-light.png" class="status-icon">
                <div class="track-desc">收货地址：北京市海淀区苏州街维亚大厦608</div>
            </div>
            <div class="track-item">
                <img src="../../assets/track-qs-light.png" class="status-icon">
                <div class="track-status">已签收</div>
                <div class="track-desc">您的订单已经从快递驿站取出，感谢您在御粮购物，欢迎再次光临～</div>
                <div class="track-date">2021-1-19 19:21:29</div>
            </div>
            <div class="track-item">
                <img src="../../assets/track-pjz.png" class="status-icon">
                <div class="track-status">派送中</div>
                <div class="track-desc">您的订单正在派送中，配送员【刘强东，<span>13888899999</span>】，请您耐心等待～</div>
                <div class="track-date">2021-1-19 19:21:29</div>
            </div> -->
            <van-steps direction="vertical" :active="0">
                <van-step v-for="(item,index) in list" :key="index">
                    <h3 style="margin:0;">{{item.opeTitle}}</h3>
                    <p style="margin:10px 0;">{{item.opeRemark}}</p>
                    <p style="margin:0;">{{item.opeTime}}</p>
                </van-step>
            </van-steps>
        </div>
        <!-- 无记录 -->
        <van-empty v-else :image=nullImg description="暂无数据~" />
    </div>
</template>
<script>
import { Icon,Notify,Toast,Step,Steps,Empty } from 'vant'
import $http from '@/lib/request'
import config from '@/config'

export default {
    data(){
        return {
            transId:'',
            orderId:'',
            list:[],
            nullImg:require('@/assets/icon-null.png'),
        }
    },
    components:{
        [Icon.name]:Icon,
        [Notify.name]:Notify,
        [Toast.name]:Toast,
        [Step.name]:Step,
        [Steps.name]:Steps,
        [Empty.name]:Empty
    },
    activated(){
        this.orderId=this.$route.params.orderId;
        $http({
            method:'post',
            url:config.api.orderTracking,
            data:{
                orderId:this.orderId
            }
        }).then(res=>{
            if(res.errno == 0){
                this.transId=res.data.expressNo;
                this.list=res.data.message;
            }else{
                Toast(res.errmsg);
            }
        })
    },
    methods:{
        copySucc(){
            Notify({ type: 'success', message: '复制成功' });
        },
        copyFail(){
            Notify({ type: 'danger', message: '复制失败' });
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .van-empty__image{
    width:140px;
    height:108px;
}
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-empty{
    margin-top: 50px;
}
.page-container{
    min-height:100vh;
    box-sizing: border-box;
    padding:10px 0;
    background:#fafafa;
    .page-top{
        background:#fff;
        border-radius: 10px;
        margin-bottom: 10px;
        .section-top{
            padding:13px 10px;
            .top-item{
                color:#333;
                font-size: 12px;
                line-height: 17px;
                margin-bottom: 10px;
                &:last-child{
                    margin-bottom: 0;
                }
                .btn-copy{
                    padding:0 6px;
                    font-size: 10px;
                    border-radius: 8px;
                    background:#f5f5f5;
                    height:16px;
                    line-height: 16px;
                    margin-left: 15px;
                }
            }
        }
        .section-bottom{
            @include flex-between();
            padding:11px 10px;
            border-top:1px solid #f0f0f0;
            font-size: 13px;
            color:#333;
            line-height: 18px;
            &>a{
                width: 80px;
                height: 28px;
                line-height: 28px;
                background: #FFFFFF;
                border-radius: 26px;
                border: 1px solid #DCDADA;
                text-align: center;
                font-size: 12px;
                color:#333;
            }
        }
        
    }
    .page-bottom{
        background:#fff;
        border-radius: 10px;
        padding:20px;
        .track-item{
            border-left:1px solid #e6e6e6;
            padding-bottom: 25px;
            padding-left: 20px;
            position: relative;
            &:last-child{
                border-left: none;
            }
            .status-icon{
                display: block;
                width:20px;
                height:20px;
                position: absolute;
                top:0;
                left:-10px;
            }
            .track-status{
                font-size: 15px;
                color:#333;
                font-weight: 500;
                line-height: 21px;
                margin-bottom: 5px;
            }
            .track-desc{
                font-size: 13px;
                color:#333;
                line-height: 20px;
                margin-bottom: 5px;
                &>span{
                    color:#3088F5;
                }
            }
            .track-date{
                font-size: 12px;
                color:#999;
                line-height: 17px;
            }
        }
    }
}
</style>